var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}pause-34`,"viewBox":"0 0 34 34"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"17","cy":"17","r":"16","fill":"none","stroke-width":"2"}}),_c('path',{staticClass:"sign",attrs:{"d":"M15,14 15,20 M19,14 19,20","fill":"none","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }